<template>
  <div style="position: relative">
    <h2 class="section-header">Əməliyyatlar</h2>
    <div style="text-align: right; position: absolute; right: 5px; top: 8px">
      <a-radio-group v-model="type" @change="handleTypeChange" class="change__type_css">
        <a-tooltip title="Cədvəl">
          <a-radio-button value="TABLE">
            <a-icon style="font-size: 20px" type="table" />
          </a-radio-button>
        </a-tooltip>

        <a-tooltip title="Siyahı">
          <a-radio-button value="LIST">
            <a-icon style="font-size: 20px" type="ordered-list" />
          </a-radio-button>
        </a-tooltip>
      </a-radio-group>
    </div>

    <a-row>
      <a-col :span="20" :offset="2">
        <a-timeline v-if="type === 'LIST'">
          <a-timeline-item
            v-for="operation in dataSource"
            :key="operation.id"
            :color="operation.direction.action.color"
          >
            <span style="font-size: 15px" v-if="operation.opUser">
              {{ getOperationText(operation) }}
            </span>
            <a-tooltip v-if="operation.note" :title="operation.note">
              <a-icon type="message" />
            </a-tooltip>

            <a-button
              style="background-color: purple; color: white; margin-left: 10px"
              v-if="operation.files && operation.files.length > 0"
              size="small"
              @click="showFiles(operation.files)"
            >
              Fayllara bax
            </a-button>

            <span v-if="operation.workResult" style="margin-left: 15px; border-left: 1px solid black; padding-left: 5px">
              İcra nəticəsi

              <a-tooltip v-if="operation.workResult.text" :title="operation.workResult.text ">
                <a-icon type="message" />
              </a-tooltip>

              <a-button
                style="background-color: purple; color: white; margin-left: 10px"
                v-if="operation.workResult.files && operation.workResult.files.length > 0"
                size="small"
                @click="showFiles(operation.workResult.files)"
              >
                İcra nəticəsi fayllarına bax
              </a-button>
            </span>
          </a-timeline-item>
        </a-timeline>
      </a-col>
    </a-row>

    <!-- </a-timeline> -->

    <a-table
      v-if="type === 'TABLE'"
      :columns="operationColumns"
      :rowKey="(record) => record.id"
      :dataSource="dataSource"
      size="middle"
      :pagination="pagination"
      :locale="mylocale"
    >
      <template slot="opUser" slot-scope="text, recod">
        {{
          (recod.opUser ? recod.opUser.firstName +  
          " " +
          recod.opUser.lastName +
          " " +
          recod.opUser.fatherName : ' Qurum əməkdaşı ') + 
          " (" +
         ( recod.userStructure ? recod.userStructure.name:'')+'  '+ recod.opUserStep.name +
          ")"
        }}
      </template>

      <template slot="addedstructure" slot-scope="text, recod">
        {{recod.addedStructure && recod.addedStructure.name}}
      </template>

      <template slot="status" slot-scope="text, recod">
        {{
          recod.direction.fromOperationStatusId
            ? recod.direction.fromOperationStatusId.name
            : ""
        }}
      </template>

      <template slot="action" slot-scope="text, recod">
        <a-button
          style="background-color: purple; color: white"
          v-if="recod.files && recod.files.length > 0"
          size="small"
          @click="showFiles(recod.files)"
        >
          Fayllara bax
        </a-button>
        <span v-else>Fayl yoxdur</span>
      </template>

      <template slot="workResult" slot-scope="text, recod">
        <div v-if="recod.workResult">
          <span style="margin-right: 10px;">{{recod.workResult && recod.workResult.text}}</span>

          <a-button
            style="background-color: purple; color: white"
            v-if="recod.workResult.files && recod.workResult.files.length > 0"
            size="small"
            @click="showFiles(recod.workResult.files)"
          >
            Fayllara bax
          </a-button>
          <span v-else>Fayl yoxdur</span>
        </div>
      </template>

      <template slot="toResult" slot-scope="text, recod">
        <div v-for="(res, index) in recod.direction.results" :key="index">
          {{ res.toStep ? res.toStep.name : "" }}
        </div>
      </template>

      <template slot="operation" slot-scope="text, record">
        {{ record.direction.action.name }}
        <a-tooltip v-if="record.note" :title="record.note">
          <a-icon type="message" />
        </a-tooltip>
      </template>
    </a-table>

    <!--media dialog-->
    <a-modal
      title="Müraciətə əlavə olunmuş fayllar"
      v-model="mediadialogVisibility"
      :footer="null"
      :width="980"
      centered
    >
      <conditional-media :filesList="files" :isVisible="mediadialogVisibility"></conditional-media>
    </a-modal>
  </div>
  <!-- </div> -->
</template>

<script>
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
const operationColumns = [
  {
    title: "İstifadəçilər",
    width: "15%",
    scopedSlots: { customRender: "opUser" },
  },

  /* { title: "Status", width: "20%", scopedSlots: { customRender: "status" } }, */
  {
    title: "Əməliyyat",
    width: "10%",
    scopedSlots: { customRender: "operation" },
  },
  { title: "Tarix", width: "10%", dataIndex: "dateStr" },
  { title: "Fayllar", width: "10%", scopedSlots: { customRender: "action" } },
  { title: "İcra nəticəsi", width: "10%", scopedSlots: { customRender: "workResult" } },
    {
    title: "Əlavə edilən qurum",
    width: "10%",
    scopedSlots: { customRender: "addedstructure" },
  },

];
export default {
  name: "OperationsTable",
  props: { dataSource: Array },
  components: {
    "conditional-media": ConditionalMedia,
  },
  data() {
    return {
      operationColumns,
      files: [],
      mediadialogVisibility: false,
      pagination: { pageSize: 6 },
      mylocale: { emptyText: "Məlumat yoxdur" },
      type: null,
    };
  },
  methods: {
    showFiles(files) {
      this.files = files;
      this.mediadialogVisibility = true;
    },
    getOperationText(operation) {
      return (
        operation.opUser?.firstName +
        " " +
        operation.opUser?.lastName +
        " " +
        operation.opUser?.fatherName +
        " (" +
        ( operation.userStructure ? operation.userStructure.name+',':'')+'  '+operation.opUserStep.name +
        ") tərəfindən " +
        operation.dateStr +
        " tarixində " +
            (operation.addedStructure?  operation.addedStructure.name+' təşkilatını ':''  ) +
        operation.direction.action.inSentence
      );
    },
    handleTypeChange(e) {
      localStorage.setItem("type", e.target.value);
    },
  },
  created() {
    if (!this.dataSource) return;
  
    const pagination = { ...this.pagination };
    pagination.total = this.dataSource.length;
    this.pagination = pagination;
    this.type = localStorage.getItem("type")
      ? localStorage.getItem("type")
      : "TABLE";
        if(window.innerWidth<1100) {
      this.type='LIST'
    }
  },
  
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
